export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/al.149273f2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};